import { render, staticRenderFns } from "./inventoryOrder.vue?vue&type=template&id=116b1504&scoped=true&"
import script from "./inventoryOrder.vue?vue&type=script&lang=js&"
export * from "./inventoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOrder.vue?vue&type=style&index=0&id=116b1504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b1504",
  null
  
)

export default component.exports